<app-component-page-header></app-component-page-header>
<ng-container *ngIf="lectureObservable | async; let lecture">
  <mat-card class="mt-4">
    <app-article-header>
      <mat-card-title [ngClass]="{'public': lecture.public}">
        <span>{{ lecture.name }}</span>
        <button mat-icon-button class="float-right edit" (click)="onEdit()" *appAuthorize="lecture.owner">
          <mat-icon>edit</mat-icon>
        </button>
        <ng-container *ngIf="!isAuthenticated && lecture.public === false">
          <button class="lock-btn float-right" mat-icon-button>
            <mat-icon>lock</mat-icon>
          </button>
        </ng-container>
        <div class="float-right">
          <app-lecture-public-button [lecture]="lecture" *appAuthorize="lecture.owner"></app-lecture-public-button>
          <app-lecture-billing-button [lecture]="lecture" *appAuthorize="lecture.owner"></app-lecture-billing-button>
          <app-lecture-members-button [lecture]="lecture">
            <button mat-icon-button *appAuthorize="lecture.owner">
              <mat-icon>people</mat-icon>
            </button>
          </app-lecture-members-button>
          <app-lesson-add-button [lecture]="lecture">
            <button mat-icon-button *appAuthorize="lecture.owner">
              <mat-icon>playlist_add</mat-icon>
            </button>
          </app-lesson-add-button>
        </div>
      </mat-card-title>
    </app-article-header>
    <app-article-content class="py-3">
      <div class="markdown-body" [innerHTML]="lecture.syllabus | markdown"></div>
    </app-article-content>
  </mat-card>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-syllabus/lecture-syllabus.component.html